module.exports = __webpack_public_path__ + "static/img/mobile_gywm_zzry_img_zzzs.85bb594.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_gywm_zzry_img_zzzs.png
// module id = PPgg
// module chunks = 21